import {getUrlParams} from '@components/utils';

type ChannelRecord = {
  adid?: string;
  tracker_name?: string;
  channel?: string;
  gps_adid?: string;
  app_token?: string;
};
let initChannel = false;
export function useChannelParams() {
  if (!initChannel) {
    initChannel = true;
    const params = getUrlParams() as ChannelRecord;
    const {adid, tracker_name, channel, gps_adid, app_token} = params;
    localStorage.setItem('adid', adid || '');
    localStorage.setItem('tracker_name', tracker_name || '');
    localStorage.setItem('channel', channel || '');
    localStorage.setItem('gps_adid', gps_adid || '');
    localStorage.setItem('app_token', app_token || '');
  }
}
